import { useQuery } from '@tanstack/react-query';
import { api } from '../../api/http';

export type Message = { kind: 'ok' | 'error'; text: string } | null;

/** The school's currency, for showing and entering fees. */
export function useCurrency(schoolId: string): string {
  const school = useQuery({
    queryKey: ['schools', schoolId],
    queryFn: () => api<{ currencyCode: string }>(`/schools/${schoolId}`),
  });
  return school.data?.currencyCode ?? 'USD';
}

export interface Hostel {
  id: string;
  name: string;
  residents: 'boys' | 'girls' | 'mixed';
  status: 'active' | 'inactive';
  wardenName: string | null;
  roomCount: number;
  beds: number;
  occupied: number;
}
export interface Room {
  id: string;
  roomNumber: string;
  floor: number | null;
  capacity: number;
  status: 'active' | 'maintenance';
  monthlyFeeMinor: number;
  occupied: number;
}
export interface Person {
  id: string;
  firstName: string;
  lastName: string;
  admissionNumber?: string;
}
